import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultMaterialMeanTemplate } from '@/utils/materialMeanDefaultTemplate';

export interface MaterialMeanFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; materialMeanJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const MaterialMeanFormDialog: React.FC<MaterialMeanFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; materialMeanJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      materialMeanJson: data.materialMeanJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New MaterialMean"
      jsonFieldName="materialMeanJson"
      defaultJsonTemplate={defaultMaterialMeanTemplate()}
      jsonLabel="Enter a valid MaterialMean JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the MaterialMean schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
